import { forwardRef } from 'react';

import { Close } from '@mui/icons-material';
import { Box, SxProps, Theme } from '@mui/material';

const customStyles: Record<string, SxProps<Theme>> = {
  root: {
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '14px',
    height: '14px',
    minWidth: '14px',
    borderRadius: '50%',
    backgroundColor: (theme: Theme) => theme.palette.primary.main,
    '& .MuiSvgIcon-root': {
      fontSize: '10px',
      width: '10px',
      height: '10px',
      color: '#FFFFFF',
    },
  },
};

/**
 * Small circular primary delete affordance used on chips (e.g. MUI Chip `deleteIcon`).
 * Forwards ref and extra props so Chip can attach handlers correctly.
 */
export const ChipCircleDeleteIcon = forwardRef<HTMLSpanElement, React.HTMLAttributes<HTMLSpanElement>>(
  function ChipCircleDeleteIcon(props, ref) {
    return (
      <Box
        component='span'
        ref={ref}
        sx={customStyles.root}
        {...props}
      >
        <Close />
      </Box>
    );
  },
);
